import { render, staticRenderFns } from "./Nearby.vue?vue&type=template&id=ff08d888&scoped=true&"
import script from "./Nearby.vue?vue&type=script&lang=js&"
export * from "./Nearby.vue?vue&type=script&lang=js&"
import style0 from "./Nearby.vue?vue&type=style&index=0&id=ff08d888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff08d888",
  null
  
)

export default component.exports